<template>
  <w-sliding-popup ref="slidingPopup" type="setting" title="키 트랜잭션 등록" @close="closePopup" width="600px">
    <div slot="content">
      <el-row class="title-bar" type="flex" justify="space-between">
        <div class="title-h4 tit">
          키 트랜잭션 목록
        </div>
        <div>
          <w-header-search-button size="mini" @click="showSearchTool = !showSearchTool" />
        </div>
      </el-row>
      <el-table-wrapper ref="keyTrsTable" :data="trsDataList" :columns="keyTrsListColumn" :total="total" remote :show-custom-header="true" :show-search-tool="showSearchTool" pagination :column-default="columnDefault"
        @selection-change="trsSelectionChange" @condition-change="loadKeyTrsData" />
    </div>
    <div slot="footer">
      <el-button size="large" type="solid" :disabled="!disabledSaveBtn" @click="saveKeyTrs">저장</el-button>
      <el-button size="large" @click="closePopup">취소</el-button>
    </div>
  </w-sliding-popup>
</template>

<script>
import { columnDefault } from '@/constants/table';
import ApmSettingAPI from '@/api/settings/apm/apm-setting';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';

export default {
  name: 'WAddTrsKeyPopup',
  props: {
    bizId: Number,
  },
  data() {
    return {
      columnDefault,
      showSearchTool: false,
      selectionRow: null,
      trsSelectionList: [],
      trsDataList: [],
      total: 0,
      keyTrsListColumn: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'webSvcMethod',
          label: '메소드',
          width: 130,
          searchable: true,
          sortable: true,
          remoteProp: 'web_svc_method',
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'webSvcUrl',
          label: 'URL',
          searchable: true,
          sortable: true,
          remoteProp: 'web_svc_url',
          formatter: this.getTableValueAfterCheckEmpty,
        },
      ],
    };
  },
  computed: {
    disabledSaveBtn() {
      return this.trsSelectionList.length > 0;
    },
  },
  methods: {
    open() {
      this.$refs.slidingPopup.visible = true;
      this.$nextTick(() => {
        this.loadKeyTrsData();
      });
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    closePopup() {
      this.trsDataList = [];
      this.total = 0;
      this.trsSelectionList = [];
      this.showSearchTool = false;
      this.$refs.keyTrsTable.clearFilter();
      this.$refs.slidingPopup.visible = false;
    },
    trsSelectionChange(row) {
      this.trsSelectionList = row;
    },
    loadKeyTrsData() {
      const params = this.$refs.keyTrsTable.getParameter();
      ApmSettingAPI.getUncoupledKeyTrsList(params).then((response) => {
        if (response.data.success) {
          this.trsDataList = response.data.data;
          this.total = response.data.total;
        } else {
          this.trsDataList = [];
          this.total = 0;
        }
      });
    },
    saveKeyTrs() {
      if (this.trsSelectionList.length < 1) {
        return;
      }

      const params = this.trsSelectionList.map((data) => {
        data.bizId = this.bizId;
        return data;
      });

      ApmSettingAPI.updateKeyTrsList(params).then((response) => {
        if (response.data.success) {
          this.$emit('reload');
          this.closePopup();
        }
        this.$message(msgUtil.getResultMsgData(msgUtil.action.REGIST, '키트랜잭션', response.data.success));
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/apm/ConfigSettings/components/popup/AddTrsKeyPopup.vue